// extracted by mini-css-extract-plugin
module.exports = {"detailRateModal":"Ai","rateHeaderRow":"Aj","closeIcon":"Ak","closeIconWrapper":"Al","rateText":"Am","rateOptionsRow":"An"};